import { createSelector } from '@ngrx/store';

import { AppState } from '../appstate.model';

export const selectSettingFeature = (state: AppState) => state.settings;

export const selectSettings = createSelector(
  selectSettingFeature,
  settingsState => settingsState.settings,
);
